/* JM Electronics - Apple-style scroll reveal animations */

(function() {
  'use strict';

  const observer = new IntersectionObserver(function(entries) {
    entries.forEach(function(entry) {
      if (entry.isIntersecting) {
        entry.target.classList.add('jm-visible');
        observer.unobserve(entry.target);
      }
    });
  }, {
    threshold: 0.15,
    rootMargin: '0px 0px -60px 0px'
  });

  function initReveal() {
    var sections = document.querySelectorAll(
      '.shopify-section .multicolumn-card,' +
      '.shopify-section .card-wrapper,' +
      '.shopify-section .rich-text__blocks,' +
      '.shopify-section .newsletter__wrapper,' +
      '.shopify-section .collection-card,' +
      '.shopify-section .banner__content'
    );

    sections.forEach(function(el, i) {
      el.classList.add('jm-reveal');
      if (i % 4 === 1) el.classList.add('jm-reveal-delay-1');
      if (i % 4 === 2) el.classList.add('jm-reveal-delay-2');
      if (i % 4 === 3) el.classList.add('jm-reveal-delay-3');
      observer.observe(el);
    });

    var bannerImages = document.querySelectorAll('.banner__media');
    bannerImages.forEach(function(el) {
      el.classList.add('jm-reveal-scale');
      observer.observe(el);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initReveal);
  } else {
    initReveal();
  }
})();
